import PromptModal from './PromptModal';
import LessonTooltip from './LessonTooltip';

import type { JourneyConfig } from '../types';

const lessonsJourney = [
  {
    name: 'prompt',
    Element: PromptModal,
    indexType: 'skip',
  },
  {
    name: 'lesson',
    Element: LessonTooltip,
  },
] as const satisfies JourneyConfig;

export default lessonsJourney;
